module.exports = __webpack_public_path__ + "static/media/IMG_0572_Reduced.8855f5b9.jpg";